import { ApolloClient } from 'apollo-client';
import { RetryLink } from 'apollo-link-retry';
import { HttpLink } from 'apollo-link-http';
import { ApolloLink } from 'apollo-link';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { isEmpty } from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import fetch from 'unfetch';
import {
  serverError, isArray, l, consts, auth,
} from 'src/utils';
import eventBus from 'src/features/eventBus';
import { BACKEND_HTTP_PATH } from 'src/config';
import settings from 'src/features/settingsByApollo';

const UNAUTHORIZED = 'unauthorized';

function logout() {
  eventBus.$emit(consts.FORCE_LOGOUT);
}

function fibonacciDelay(attempt) {
  const fib = (n) => (n <= 1 ? n : fib(n - 1) + fib(n - 2));
  return fib(attempt) * 1000 + Math.random() * 1000; // Фибоначчи в миллисекундах + размазывание
}

const httpLink = new HttpLink({
  uri: `${BACKEND_HTTP_PATH}api`,
  fetch,
});

const middlewareLink = new ApolloLink((operation, forward) => {
  if (operation.operationName) {
    const params = isEmpty(operation.variables) ? 'без параметров' : `с параметрами ${JSON.stringify(operation.variables)}`;
    l.info(`Выполнен запрос GQL ${operation.operationName} ${params}`);
  }

  const jwt = auth.getToken(settings.getCurrentToken());
  operation.setContext({
    headers: {
      authorization: `Bearer ${jwt}`,
    },
  });

  return forward(operation);
});

const afterwareLink = new ApolloLink((operation, forward) => forward(operation).map((response) => {
  const {
    response: { status },
  } = operation.getContext();
  const { errors } = response;
  if (status === 401) {
    l.error(`Произошел выход из системы  (причина ${status})`);
    logout();
  } else if (errors && isArray(errors)) {
    errors.forEach((item) => {
      if (item.message.indexOf(UNAUTHORIZED) > -1) {
        logout();
      } else if (item.error) {
        if (item.error.code === consts.UNAUTHORIZED) {
          logout();
        } else {
          serverError.handle(item.error, item.path[0], item.message, item.payload);
        }
      }
    });
  } else if (errors) {
    l.error('errors must be array');
    l.error(`errors = ${JSON.stringify(errors)}`);
  }

  return response;
}));

const retryLink = new RetryLink({
  delay: {
    initial: 1000 + Math.random() * 1000,
    max: Infinity,
    jitter: false,
  },
  attempts: {
    max: 5,
    delay: fibonacciDelay,
    retryIf: (error, operation) => {
      const { response } = operation.getContext();
      if (response && (response.status === 401 || response.status === 403 || response.status === 500)) {
        return false;
      }
      return !!error;
    },
  },
});

const link = ApolloLink.from([retryLink, middlewareLink, afterwareLink, httpLink]);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

export default { client };
